// extracted by mini-css-extract-plugin
module.exports = {"spinner":"aed17b9412--spinner--uXgOG","circle-spin":"aed17b9412--circle-spin--HhIQz"};